import { render, staticRenderFns } from "./PointSolutionVendorDetails.vue?vue&type=template&id=f70c0fcc&scoped=true&"
import script from "./PointSolutionVendorDetails.vue?vue&type=script&lang=js&"
export * from "./PointSolutionVendorDetails.vue?vue&type=script&lang=js&"
import style0 from "./PointSolutionVendorDetails.vue?vue&type=style&index=0&id=f70c0fcc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c0fcc",
  null
  
)

export default component.exports